export const STATUS_APPROVED = 'APRV';
export const PASS_FAIL_SELECTION = ['PASS', 'FAIL'];
